import { render, staticRenderFns } from "./club-complaint.vue?vue&type=template&id=0396362c&scoped=true&"
import script from "./club-complaint.vue?vue&type=script&lang=js&"
export * from "./club-complaint.vue?vue&type=script&lang=js&"
import style0 from "./club-complaint.vue?vue&type=style&index=0&id=0396362c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396362c",
  null
  
)

export default component.exports